import A from '../../constants/actions';
import M from '../../constants/mutations';
import Vue from 'vue';

const state = {
  feedback: {
    name: '',
    email: undefined,
    description: '',
    date: new Date(),
  }
};

const actions = {

  [A.FEEDBACK_CREATE_NEW]({ commit }) {
    commit(M.FEEDBACK_CREATE_NEW);
  },

  [A.FEEDBACK_UPDATE_PROPERTY]({commit}, config) {
    commit(M.FEEDBACK_UPDATE_PROPERTY, config);
  },
}

const mutations = {

  [M.FEEDBACK_CREATE_NEW](state) {
    state.feedback = {
      name: '',
      email: undefined,
      description: '',
      date: new Date(),
    }
  },

  [M.FEEDBACK_UPDATE_PROPERTY](state, config) {
    Vue.set(state.feedback, config.name, config.value);
  },
}

export default {
  state,
  actions,
  mutations,
};
